module.exports = __webpack_public_path__ + "static/media/sound4.b2c95b4.ogg";